import { css } from 'aphrodite';
import { useLocation } from 'react-router';
import { CoffeeProgressBar } from '../components/CoffeeProgressBar';
import { StatusBanner } from '../components/StatusBanner';
import { styleSheet } from './styles';

const showsGamification = (pathname?: string) =>
	!!pathname && !pathname.includes('settings') && !pathname.includes('reporting');

export const CoffeeSubBar = () => {
	const { pathname } = useLocation();
	if (!showsGamification(pathname)) {
		return null;
	}
	return (
		<div className={css(styleSheet.subBar)}>
			<StatusBanner styles={[styleSheet.statusBannerInGrid]} />
			<CoffeeProgressBar className={css(styleSheet.progressBar)} />
		</div>
	);
};
